// extracted by mini-css-extract-plugin
module.exports = {"cart-items":"Cart_cart-items__2x-Xr","total":"Cart_total__bh6wM","actions":"Cart_actions__OWyPs","button--alt":"Cart_button--alt__6TKJ0","button":"Cart_button__yqds9"};